require.context('../images', true, /\.(png|jpe?g|svg)$/);